import React from 'react'
import { BrowserRouter as Router} from 'react-router-dom'
import {red900, red700, red400, pinkA200} from 'material-ui/styles/colors'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import Routes from './Routes'
import ProgressContainer from '../containers/ProgressContainer'
import SnackbarContainer from '../containers/SnackbarContainer'

const muiTheme = getMuiTheme({
	palette: {
		primary1Color: red700,
		primary2Color: red900,
		accent1Color: pinkA200,
	},
	tabs: {
		backgroundColor: red400
	},
	textField: {
		 floatingLabelColor: "#7396c4"
	},
	tableHeaderColumn: {
		 textColor: "#7396c4"
	}
})

const App = () => (
	<MuiThemeProvider muiTheme={muiTheme}>
		<Router basename="/cms/bac">
			<div>
			<Routes />
			<ProgressContainer />
			<SnackbarContainer />
			</div>
		</Router>
	</MuiThemeProvider>
)

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js